import React, { useState } from 'react';
import * as FiIcons from 'react-icons/fi';
import { Link } from 'react-router-dom';

interface FABAction {
    id: string;
    label: string;
    icon: React.ReactNode;
    href?: string;
    onClick?: () => void;
    color?: string;
}

interface MobileFABProps {
    actions: FABAction[];
    mainAction?: FABAction;
    className?: string;
}

const MobileFAB: React.FC<MobileFABProps> = ({
    actions,
    mainAction,
    className = ""
}) => {
    const [isOpen, setIsOpen] = useState(false);

    const toggleFAB = () => {
        setIsOpen(!isOpen);
    };

    const handleActionClick = (action: FABAction) => {
        if (action.onClick) {
            action.onClick();
        }
        setIsOpen(false);
    };

    const renderAction = (action: FABAction, index: number) => {
        const actionContent = (
            <div className="flex items-center space-x-3">
                <div className={`w-10 h-10 rounded-full flex items-center justify-center text-white ${action.color || 'bg-primary-500'}`}>
                    {action.icon}
                </div>
                <span className="text-sm font-medium text-monday-text bg-white px-3 py-1.5 rounded shadow-md whitespace-nowrap">
                    {action.label}
                </span>
            </div>
        );

        if (action.href) {
            return (
                <Link
                    key={action.id}
                    to={action.href}
                    className="block"
                    onClick={() => setIsOpen(false)}
                >
                    {actionContent}
                </Link>
            );
        }

        return (
            <button
                key={action.id}
                onClick={() => handleActionClick(action)}
                className="block w-full text-left"
            >
                {actionContent}
            </button>
        );
    };

    return (
        <div className={`fixed bottom-6 right-6 z-[100] ${className}`}>
            {/* Action Menu */}
            {isOpen && (
                <div className="absolute bottom-16 right-0 mb-4 space-y-3 mobile-fab-menu">
                    {actions.map((action, index) => (
                        <div
                            key={action.id}
                            className="animate-scaleIn"
                            style={{ animationDelay: `${index * 100}ms` }}
                        >
                            {renderAction(action, index)}
                        </div>
                    ))}
                </div>
            )}

            {/* Main FAB Button */}
            <button
                onClick={toggleFAB}
                className={`mobile-fab ${isOpen ? 'bg-error-500 hover:bg-error-600' : 'bg-primary-500 hover:bg-primary-600'}`}
                aria-label={isOpen ? 'Close menu' : 'Open menu'}
            >
                {isOpen ? (
                    FiIcons.FiX({ size: 24 })
                ) : (
                    mainAction?.icon || FiIcons.FiPlus({ size: 24 })
                )}
            </button>

            {/* Backdrop for closing */}
            {isOpen && (
                <div
                    className="fixed inset-0 z-[99] bg-black/20"
                    onClick={() => setIsOpen(false)}
                />
            )}
        </div>
    );
};

export default MobileFAB; 